import type { UploadProgressStep } from './sse-upload'

const SUPPORTED_DOCUMENT_FORMATS = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/html',
  'text/plain',
  'text/markdown',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
] as const

const SUPPORTED_AUDIO_FORMATS = [
  'audio/ogg',
  'audio/webm',
  'audio/m4a',
  'audio/x-m4a',
  'audio/m4v',
  'audio/mp3',
  'audio/mpeg',
  'audio/wav',
] as const

const SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/jpg', 'image/png'] as const

export const SUPPORTED_FORMATS = [
  ...SUPPORTED_DOCUMENT_FORMATS,
  ...SUPPORTED_IMAGE_FORMATS,
  ...SUPPORTED_AUDIO_FORMATS,
] as const

type SupportedImageFormat = (typeof SUPPORTED_IMAGE_FORMATS)[number]
export type SupportedFormat = (typeof SUPPORTED_FORMATS)[number]

export const getFileExtension = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf('.')
  return lastDotIndex === -1 ? '' : filename.substring(lastDotIndex).toLowerCase()
}

const UPLOAD_PROGRESS_LABELS: Record<UploadProgressStep, string> = {
  upload: 'Enviando…',
  extract: 'Extraindo…',
  'document-converter': 'Convertendo…',
  index: 'Catalogando…',
}
export function getUploadProgressLabel(step: string): string {
  if (step in UPLOAD_PROGRESS_LABELS) {
    return UPLOAD_PROGRESS_LABELS[step as UploadProgressStep]
  }
  return 'Processando…'
}

const friendlyErrorMessages = {
  unknown: 'Erro ao carregar arquivo',
  unsupported: 'Formato de arquivo não suportado',
  imageWrongSize: 'Imagem muito grande. Envie uma com até 30 MB e resolução 8k.',
  wrongSize: 'Anexo muito grande. Envie um arquivo com até 150 MB.',
}

export function translateFriendlyError(
  error: string | undefined,
  mimeType: string,
  friendlyError: string | undefined
) {
  let errorMessage = friendlyError || friendlyErrorMessages.unknown
  if (error?.includes('not supported')) {
    errorMessage = friendlyErrorMessages.unsupported
  } else if (error === 'File too large') {
    if (SUPPORTED_IMAGE_FORMATS.includes(mimeType as SupportedImageFormat)) {
      errorMessage = friendlyErrorMessages.imageWrongSize
    } else {
      errorMessage = friendlyErrorMessages.wrongSize
    }
  }
  return errorMessage
}
